import { render, staticRenderFns } from "./TaskFirstRowInfo.vue?vue&type=template&id=7d96108b&scoped=true"
import script from "./TaskFirstRowInfo.vue?vue&type=script&lang=js"
export * from "./TaskFirstRowInfo.vue?vue&type=script&lang=js"
import style0 from "./TaskFirstRowInfo.vue?vue&type=style&index=0&id=7d96108b&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d96108b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VLayout,VTooltip})
